module.exports = __webpack_public_path__ + "img/home-delivery.2f9e5012.svg";